import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { Result, Button } from 'antd'

class Success extends React.Component {
    state = {
        subTitle: '',
        extra: '',
    }

    redirectLogin = (e) => {
        this.props.history.push('/user/login')
    }

    result = {
        register: {
            title: 'Register success!',
            subTitle: 'Please check the email and activate your account, then you can login.',
            extra: <Button type="primary" onClick={this.redirectLogin}>Log in</Button>,
        },
        resetPwdEmail: {
            title: 'Successfully Request!',
            subTitle: 'Email has been send, you can update your password and login.',
            extra: <Button type="primary" onClick={this.redirectLogin}>Log in</Button>, 
        },
        resetPwd: {
            title: 'Successfully Request!',
            subTitle: 'Password reset success. You can login in now.',
            extra: <Button type="primary" onClick={this.redirectLogin}>Log in</Button>,
        }
    }

    componentDidMount() {
        const pathSnippets = this.props.location.pathname.split('/').filter(i => i)
        this.props.setPathSnippetsState(pathSnippets)
        
        const result = this.result
        const action = this.props.match.params.action
        if (action in result) {
            this.setState({
                subTitle: result[action].subTitle,
                extra: result[action].extra
            })
        }
    }

    render() {
        const { subTitle, extra } = this.state
        return (
            <Result
                status="success"
                title="Successfully Request!"
                subTitle={subTitle}
                extra={extra}
            />
        )
    }
}

Success.propTypes = {
    setPathSnippetsState: PropTypes.func
}

export default withRouter(Success)